<template>
    <div v-show="isShow">
        <div class="confirm-dialog-box">
            <div class="text">{{ text }}</div>
            <div class="confirm">
                <div class="cancel" @click="cancelDraft">不保留</div>
                <div class="button" @click="saveDraft">
                    <span v-show="!isLoading">保留</span>
                    <van-loading color="#ea6f7b" size="24px" v-show="isLoading"/>
                </div>
            </div>
        </div>
        <div class="shadow"></div>
    </div>
</template>

<script>
export default {
  name: 'ConfirmSave',
  components: {
  },
  data(){
      return {
          isShow: false,
          isLoading: false,
          text:'是否保留此次编辑?',
      }
  },
  methods:{
        showLoading(){
            this.isLoading = !this.isLoading
        },
        show(){
            this.isShow = !this.isShow
        },
        saveDraft(){
            this.$bus.$emit('saveDraft')
        },
        cancelDraft(){
            this.$bus.$emit('deleteDraft')
            this.isShow = false
            this.$router.back()
        }
  },
  props:{

  }
}
</script>

<style scoped lang="scss">
.shadow {
    position: fixed;
    z-index: 100;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,0.3);
}
.confirm-dialog-box {
    width: 80%;
    max-width: 625px;
    line-height: 50px;
    margin: 0 auto;
    color: #000;
    background: #FFF;
    max-width: 625px;
    margin: 0 auto;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 20px;
    position: fixed;
    border-radius: 5px;
    top: 40%;
    z-index: 999;
    .text {
        font-size: 16px;
        padding: 20px 0;
        border-bottom: 1px solid #cdcdcd;
    }
    .confirm {
        display: flex;
        .button {
            width: 50%;
            font-size: 18px;
            color: #eb411f;
        }
        .cancel {
            width: 50%;
            font-size: 18px;
            color: #000;
            border-right: 1px solid #cdcdcd;
        }
    }
}
.van-loading {
    position: relative !important;
    left: 0;
    right: 0;
    top: 2px;
    transform: none;
    -webkit-transform: none;
    -ms-transform: none;
    font-size: 0;
    vertical-align: middle;
    -ms-transform: none;
}
</style>
